import * as cart from '../types/cart'
import { BOLETO } from '../../constants/payment-type'
import * as productData from 'constants/product-types'

export const initialState = {
    total: 0,
    open: false,
    id: '',
    code: null,
    status: '',
    maxCard: 0,
    error: false,
    company: {
        document: '',
        name: '',
        fantasyName: '',
        companySize: '',
        companyType: '',
        numberOfEmployees: '',
        dateOfEstablishment: '',
        cityInscription: '',
        stateInscription: '',
        cnaeSectionCode: '',
        cnaeDivisionType: '',
        tradeName: '',
        deliveryAddress: {
            postalCode: '',
            state: '',
            city: '',
            street: '',
            number: '',
            additionalInfo: '',
            neighborhood: ''
        },
        billingAddress: {
            postalCode: '',
            state: '',
            city: '',
            street: '',
            number: '',
            additionalInfo: '',
            neighborhood: ''
        },
        stakeholders: [],
        hasPATNumber: '',
        patNumber: ''
    },
    spokesman: {
        documentNumber: '',
        name: '',
        phone: '',
        email: '',
        birthDate: ''
    },
    management: null,
    products: [],
    upSellFeeClosed: false,
    upSellFeeTarget: null,
    paymentType: BOLETO,
    feeLoading: false,
    feeError: false,
    postalCodeLoading: false,
    proposalEmail: null,
    documentVerification: {
        valid: null,
        unavailableProductCodes: []
    },
    postalCodeError: '',
    contract: [],
    contracts: [],
    cookiesAccepted: {
        accept: true,
        datetime: ''
    },
    recovery: false,
    fees: []
}

const getDefaultGroupItem = (p) => ({
    type: p.type ?? '',
    qnt: p.qnt ?? 0.0,
    value: p.value ?? 0.0,
    total: p.total ?? 0.0,
    adminstrationTax: p.adminstrationTax ?? 0.0,
    feeType: p.feeType ?? 'PERCENTAGE',
    totalFee: p.totalFee ?? 0.0
})

const checkHasPatNumber = (cartData) => {
    if (cartData.company.patNumber === undefined) return ''

    if (cartData.company.patNumber) {
        return '1'
    }

    return '0'
}

const checkPatNumber = (cartData) => {
    if (cartData.company.patNumber === undefined) return ''
    return cartData.company.patNumber
}

const getDefaultNeighborhood = (district) => {
    if (district) return district
    return ''
}

const getDefaultStreet = (street) => {
    if (street) return street
    return ''
}

export const cartReducer = (state = initialState, action = { type: '' }) => {
    switch (action.type) {
        case cart.TOGGLE_MODAL:
            return { ...state, open: !state.open }
        case cart.OPEN_MODAL:
            return { ...state, open: true }
        case cart.CLOSE_MODAL:
            return { ...state, open: false }
        case cart.ADD_EDIT_PRODUCT:
            return makeAddEditProduct(state, action)
        case cart.ADD_GROUP_ITEM: {
            const productIndex = state.products.findIndex(
                (product) => +product.id === action.code
            )

            const products = state.products
            let groupItems = state.products[productIndex].groups.items
            groupItems.push(action.payload)

            return {
                ...state,
                products: [
                    ...products.slice(0, productIndex),
                    {
                        ...products[productIndex],
                        groups: {
                            ...products[productIndex].groups,
                            items: groupItems
                        }
                    },
                    ...products.slice(productIndex + 1)
                ]
            }
        }
        case cart.REMOVE_PRODUCT:
            return {
                ...state,
                products: state.products.filter(
                    (product) => product.id !== action.payload.id
                )
            }
        case cart.SET_GROUP_ITEM_VALUE:
            return makeSetGroupItemValue(state, action)
        case cart.SET_GROUP_ITEM_QNT:
            return makeSetGroupItemQnt(state, action)
        case cart.SET_VALUE_PRODUCT:
            return {
                ...state,
                products: [
                    ...state.products.slice(0, action.payload.index),
                    {
                        ...state.products[action.payload.index],
                        value: action.payload.value,
                        total:
                            parseFloat(action.payload.value) *
                            state.products[action.payload.index].qnt
                    },
                    ...state.products.slice(action.payload.index + 1)
                ]
            }
        case cart.SET_QNT_PRODUCT:
            return {
                ...state,
                products: [
                    ...state.products.slice(0, action.payload.index),
                    {
                        ...state.products[action.payload.index],
                        qnt: action.payload.qnt,
                        total:
                            action.payload.qnt *
                            parseFloat(
                                state.products[action.payload.index].value
                            )
                    },
                    ...state.products.slice(action.payload.index + 1)
                ]
            }
        case cart.SET_COMPANY_DOCUMENT:
            return {
                ...state,
                company: {
                    ...state.company,
                    document: action.value
                }
            }
        case cart.SET_COMPANY_NAME:
            return {
                ...state,
                company: {
                    ...state.company,
                    name: action.value
                }
            }
        case cart.SET_COMPANY_DATA: {
            const data = action.payload.data

            return {
                ...state,
                company: {
                    ...state.company,
                    name: data.companyName,
                    fantasyName: data.fantasyName,
                    tradeName: data.companyTradeName,
                    deliveryAddress: {
                        postalCode: data.deliveryPostalCode,
                        state: data.deliveryState,
                        city: data.deliveryCity,
                        street: data.deliveryStreet,
                        neighborhood: data.deliveryNeighborhood,
                        number: data.deliveryNumber,
                        additionalInfo: data.deliveryComplement
                    },
                    billingAddress: {
                        postalCode: data.billingPostalCode,
                        state: data.billingState,
                        city: data.billingCity,
                        street: data.billingStreet,
                        neighborhood: data.billingNeighborhood,
                        number: data.billingNumber,
                        additionalInfo: data.billingComplement
                    },
                    dateOfEstablishment: data.dateOfEstablishment,
                    numberOfEmployees: data.numberOfEmployees,
                    companyType: data.companyType,
                    companySize: data.companySize,
                    cityInscription: data.cityInscription,
                    stateInscription: data.stateInscription,
                    cnaeSectionCode: data.cnaeSectionCode,
                    cnaeDivisionType: data.cnaeDivisionType,
                    stakeholders: data.stakeholders,
                    hasPATNumber: data.companyHasPAT,
                    patNumber: data.companyPATNumber
                }
            }
        }
        case cart.SET_CART_DATA:
            return {
                ...state,
                id: action.id,
                code: action.code,
                status: action.status,
                maxCard: action.maxCard
            }
        case cart.SET_SPOKESMAN:
            return {
                ...state,
                spokesman: {
                    ...state.spokesman,
                    name: action.name,
                    phone: action.phone,
                    email: action.email,
                    documentNumber: action.doc,
                    birthDate: action.birthDate
                }
            }
        case cart.SET_SPOKESMEN_DATA:
            return {
                ...state,
                [action.kind]: {
                    ...state[action.kind],
                    name: action.name,
                    phone: action.phone,
                    email: action.email,
                    documentNumber: action.documentNumber,
                    birthDate: action.birthDate
                }
            }
        case cart.START_POSTAL_CODE_SEARCH:
            return {
                ...state,
                postalCodeLoading: true,
                postalCodeError: ''
            }
        case cart.SET_POSTAL_CODE_ERROR:
            return {
                ...state,
                postalCodeLoading: false,
                postalCodeError: action.payload.error
            }
        case cart.SET_COMPANY_ADDRESSES:
            return {
                ...state,
                company: {
                    ...state.company,
                    deliveryAddress: {
                        ...state.company.deliveryAddress,
                        postalCode: action.payload.postalCode,
                        state: action.payload.state,
                        city: action.payload.city,
                        street: getDefaultStreet(action.payload.street),
                        neighborhood: getDefaultNeighborhood(
                            action.payload.district
                        )
                    },
                    billingAddress: {
                        ...state.company.billingAddress,
                        postalCode: action.payload.postalCode,
                        state: action.payload.state,
                        city: action.payload.city,
                        street: action.payload.street,
                        neighborhood: action.payload.district
                    }
                },
                postalCodeLoading: false,
                postalCodeError: ''
            }
        case cart.SET_PAT: {
            const productIndex = state.products.findIndex(
                (product) => +product.id === action.code
            )

            return {
                ...state,
                products: [
                    ...state.products.slice(0, productIndex),
                    {
                        ...state.products[productIndex],
                        isPat: action.isPat
                    },
                    ...state.products.slice(productIndex + 1)
                ],
                feeError: false
            }
        }
        case cart.SET_FEE: {
            const productIndex = state.products.findIndex(
                (product) => +product.id === action.code
            )

            return {
                ...state,
                products: [
                    ...state.products.slice(0, productIndex),
                    {
                        ...state.products[productIndex],
                        fees: action.payload.fees,
                        totalFee: action.payload.totalFee
                    },
                    ...state.products.slice(productIndex + 1)
                ],
                feeError: false
            }
        }
        case cart.SET_POD_TUDO_FEE:
            return makeSetPodTudoFee(state, action)
        case cart.SET_TOTAL_FEE: {
            return {
                ...state,
                fees: action.payload.fees,
                total: action.payload.total
            }
        }
        case cart.CLOSE_UP_SELL_FEE: {
            return {
                ...state,
                upSellFeeClosed: true
            }
        }
        case cart.SET_UP_SELL_FEE_TARGET: {
            return {
                ...state,
                upSellFeeTarget: action.payload.code
            }
        }
        case cart.SET_FEE_ERROR:
            return {
                ...state,
                feeError: true
            }
        case cart.CLEAR_CART: {
            return { ...initialState, cookiesAccepted: state.cookiesAccepted }
        }
        case cart.CLEAR_NEW_PRODUCT: {
            return {
                ...state,
                products: state.products.map((product) => ({
                    ...product,
                    new: false
                }))
            }
        }
        case cart.ADD_NEW_PRODUCT:
            return makeAddNewProduct(state, action)
        case cart.CHANGE_PAYMENT_TYPE:
            return {
                ...state,
                paymentType: action.payload.type
            }
        case cart.SET_CONTRACT_DATA:
            return {
                ...state,
                contract: action.payload.contract
            }
        case cart.SET_CONTRACTS:
            return {
                ...state,
                contracts: action.payload.contracts
            }
        case cart.SET_SPOKESMAN_DOCUMENT:
            return {
                ...state,
                spokesman: {
                    ...state.spokesman,
                    documentNumber: action.doc
                }
            }
        case cart.SET_DOCUMENT_VERIFICATION:
            return {
                ...state,
                documentVerification: {
                    ...state.documentVerification,
                    valid: action.valid,
                    unavailableProductCodes: action.unavailableProductCodes
                }
            }
        case cart.CLOSE_PRIVACITY_TERMS:
            return {
                ...state,
                cookiesAccepted: { ...state.cookiesAccepted, accept: false }
            }
        case cart.ACCEPT_PRIVACITY_TERMS:
            return {
                ...state,
                cookiesAccepted: {
                    accept: true,
                    datetime: action.payload.datetime
                }
            }
        case cart.FILL_BUREAU_DATA:
            return {
                ...state,
                company: {
                    ...state.company,
                    ...action.payload.data
                }
            }
        case cart.FILL_CART_PRODUCT:
            return {
                ...state,
                products: [
                    ...state.products,
                    ...action.payload.products.filter(
                        (p) => !state.products.some((prod) => prod.id === p.id)
                    )
                ]
            }
        case cart.RECOVERY_CART:
            return makeRecoveryCart(state, action)
        case cart.RESET:
            return initialState
        case cart.SET_RECOVERY_CART: {
            const cartData = action.payload.data

            return {
                ...state,
                recovery: true,
                id: cartData.id,
                code: cartData.code,
                status: cartData.status,
                maxCard: cartData.max_card_pme,
                company: {
                    ...state.company,
                    document: cartData.company.document,
                    name: cartData.company.businessName,
                    tradeName: cartData.company.nameAtCard,
                    deliveryAddress: {
                        postalCode: cartData.company.deliveryAddress.postalCode,
                        state: cartData.company.deliveryAddress.state,
                        city: cartData.company.deliveryAddress.city,
                        street: cartData.company.deliveryAddress.street,
                        number: cartData.company.deliveryAddress.number,
                        additionalInfo: '',
                        neighborhood: ''
                    },
                    billingAddress: {
                        postalCode: cartData.company.billingAddress.postalCode,
                        state: cartData.company.billingAddress.state,
                        city: cartData.company.billingAddress.city,
                        street: cartData.company.billingAddress.street,
                        number: cartData.company.billingAddress.number,
                        additionalInfo: '',
                        neighborhood: ''
                    },
                    hasPATNumber: checkHasPatNumber(cartData),
                    patNumber: checkPatNumber(cartData)
                },
                spokesman: {
                    documentNumber: cartData.spokesman.documentNumber,
                    name: cartData.spokesman.name,
                    phone:
                        cartData.spokesman.prefixNumber +
                        cartData.spokesman.phone,
                    email: cartData.spokesman.email,
                    birthDate: cartData.spokesman.birthday
                },
                products: cartData.products.map((product) => ({
                    id: parseInt(product.code),
                    qnt: product.amount,
                    value: product.paymentValue.toFixed(2),
                    total: product.amount * product.paymentValue,
                    loading: false,
                    fees: []
                }))
            }
        }
        case cart.RESET_SPOKESMAN:
            return {
                ...state,
                spokesman: {
                    documentNumber: '',
                    name: '',
                    phone: '',
                    email: '',
                    birthDate: ''
                }
            }
        default:
            return state
    }
}

function makeSetGroupItemValue(state, action) {
    const value = action.payload.value
    const productIndex = action.payload.productIndex

    const products = state.products
    const groupItems = state.products[productIndex].groups.items

    return {
        ...state,
        products: [
            ...products.slice(0, productIndex),
            {
                ...products[productIndex],
                groups: {
                    ...products[productIndex].groups,
                    items: groupItems.map((item) => {
                        if (item.type !== action.payload.itemType) {
                            return item
                        }

                        return {
                            ...item,
                            value: value
                        }
                    })
                }
            },
            ...products.slice(productIndex + 1)
        ]
    }
}

function makeSetGroupItemQnt(state, action) {
    const qnt = action.payload.qnt
    const productIndex = action.payload.productIndex

    const products = state.products
    const groupItems = state.products[productIndex].groups.items

    return {
        ...state,
        products: [
            ...products.slice(0, productIndex),
            {
                ...products[productIndex],
                groups: {
                    ...products[productIndex].groups,
                    items: groupItems.map((item) => {
                        if (item.type !== action.payload.itemType) {
                            return item
                        }

                        return {
                            ...item,
                            qnt: qnt
                        }
                    })
                }
            },
            ...products.slice(productIndex + 1)
        ]
    }
}

function makeSetPodTudoFee(state, action) {
    const productIndex = state.products.findIndex(
        (product) => +product.id === action.code
    )

    return {
        ...state,
        products: [
            ...state.products.slice(0, productIndex),
            {
                ...state.products[productIndex],
                fees: action.productFees,
                groups: {
                    ...action.groups,
                    items: action.groups.items.map((p) => {
                        return {
                            ...p,
                            qnt: p.quantity ?? 0.0
                        }
                    })
                }
            },
            ...state.products.slice(productIndex + 1)
        ],
        feeError: false
    }
}

function makeAddEditProduct(state, action) {
    const productIndex = state.products.findIndex(
        (product) => +product.id === action.payload.product.id
    )

    const index = productIndex > -1 ? productIndex : state.products.length

    return {
        ...state,
        products: [
            ...state.products.slice(0, index),
            action.payload.product,
            ...state.products.slice(index + 1)
        ]
    }
}

function makeAddNewProduct(state, action) {
    const productIndex = state.products.findIndex(
        (product) => +product.id === action.payload.product.id
    )

    const index = productIndex > -1 ? productIndex : state.products.length

    const products = state.products.map((product) => ({
        ...product,
        new: false
    }))

    return {
        ...state,
        products: [
            ...products.slice(0, index),
            {
                ...action.payload.product,
                new: productIndex === -1
            },
            ...products.slice(index + 1)
        ]
    }
}

function makeRecoveryCart(state, action) {
    const products = action.payload.products
    const bank = action.payload.bank

    if (bank) {
        return {
            ...state,
            products: products
                .filter((p) => p.id)
                .filter(
                    (product) =>
                        ![productData.POD, productData.TUDO].includes(
                            product.id
                        )
                )
        }
    }

    return {
        ...state,
        products: products
            .filter((product) => product.id)
            .map((product) => {
                if (!product.groups) {
                    return product
                }

                return {
                    ...product,
                    groups: {
                        items: product.groups.items
                            ? product.groups.items.map(getDefaultGroupItem)
                            : product.groups.map(getDefaultGroupItem),
                        total: product.groups.total ?? 0.0,
                        totalFee: product.groups.totalFee ?? 0.0
                    }
                }
            })
    }
}
